// Red tabele „Odgovornost i ovlašćenje" procedure kao tekst.
// Unos na ekranu čuva employee_name/designation_name, uvoz iz Excela description;
// employee/designation su stariji ključevi.
export const formatResponsibilityRow = (row) => {
  if (!row || typeof row !== "object") return String(row || "").trim();
  return [
    row.employee_name || row.employee,
    row.designation_name || row.designation,
    row.description,
  ]
    .map((v) => String(v || "").trim())
    .filter(Boolean)
    .join(" — ");
};
